// React app is intentionally disabled so the static landing page
// in /public/index.html is shown as-is. The hidden <div id="root">
// in index.html keeps React's mount target happy.
export default function App() {
  return null;
}
